var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4484ecc0","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/project_avatar/image.vue
// module id = null
// module chunks = 